import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProfileMin } from '../../../../profiles/shared/profile-min.model';
import { ProfileRead } from '../../../../profiles/shared/profile-read.model';
import { UtilService, DialogService } from '../../../../shared/index';
import { EventRead } from '../../../shared/event-read.model';
import { RegistrationUpsert } from '../../shared/crud/registration-upsert.model';
import { RegistrationAttendee } from '../../shared/registration-attendee.model';
import { RegistrationAttendeeItem } from '../../shared/registration-attendee-item.model';
import { RegistrationAttendeeItemCustomResponse } from '../../shared/registration-attendee-item-custom-response.model';
import { RegistrationItem } from '../../shared/registration-item.model';
import { RegistrationItemCustomField } from '../../shared/registration-item-custom-field.model';
import { RegistrationItemCustomFieldAvailableValue } from '../../shared/registration-item-custom-field-avail-value.model';
import { RegistrationItemCustomFieldAvailableValueCreditType } from '../../shared/registration-item-custom-field-avail-value-credit-type.model';
import { EventItemService } from '../../../shared/items/event-item.service';
import { EventItemSummary } from '../../../shared/items/event-item-summary.model';
import { EventSponsor } from '../../../shared/sponsors/event-sponsor.model';
import { EventSponsorsService } from '../../../shared/sponsors/event-sponsors.service';
import { RegistrationItemSponsor } from '../../shared/registration-item-sponsor.model';
import { IValidationComponent } from '../../../../shared/widgets/component/ivalidation.component';
import { ValidationResult } from '../../../../shared/widgets/validators/validation-result.model';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { ImageLookupComponent } from '../../../../config/image-lookup/image-lookup.component';

@Component({
  selector: 'wl-registration-wizard-sponsor',
  templateUrl: 'registration-wizard-sponsor.component.html',
  providers: [EventItemService, EventSponsorsService],
    standalone: false
})
export class RegistrationWizardSponsorComponent implements OnInit, IValidationComponent {
  @ViewChild('sponsorImageSelector', { static: false }) sponsorImageSelector: ImageLookupComponent;

  public registrationId: number;
  public registration: RegistrationUpsert = new RegistrationUpsert();
  public event: EventRead = new EventRead();
  public initialLoadComplete: boolean = false;

  public _utilService: UtilService;
  public _translationService: TranslationService;

  public _eventItemService: EventItemService;
  public _eventSponsorService: EventSponsorsService;

  public sponsor: RegistrationItemSponsor;
  public availableItems: Array<EventItemSummary>;
  public itemTotal: number;

  public _invertedDoNotDisplay: boolean = true;

  public constructor(
    utilService: UtilService,
    eventItemService: EventItemService,
    eventSponsorService: EventSponsorsService,
    translationService: TranslationService
  ) {
    this._utilService = utilService;
    this._eventItemService = eventItemService;
    this._eventSponsorService = eventSponsorService;
    this._translationService = translationService;

    this.sponsor = new RegistrationItemSponsor();
    this.availableItems = new Array<EventItemSummary>();

    this.itemTotal = 0;
    this.registrationId = 0;
  }

  ngOnInit() {}

  public loadData = (profile?: ProfileMin): void => {
    let eventId = this.event.EventId;

    if (this.registration.IsEdit == true) {
      for (let regItem of this.registration.Items) {
        if (regItem.IsSponsorShip == true) {
          if (this._utilService.isNotNullOrUndefined(regItem.Sponsor)) {
            if (this._utilService.isNotNullEmptyOrWhitespace(regItem.Sponsor.SponsorName)) {
              this.sponsor = regItem.Sponsor;
              break;
            }
          }
        }
      }
    }

    if (this.sponsor.SponserId <= 0) {
      // don't assume it should be created during edit
      if (this.registration.IsEdit) {
        this.sponsor.DoNotDisplay = true;
        this._invertedDoNotDisplay = false;
      }

      //set default sponsor info
      if (this._utilService.isNullEmptyOrWhitespace(this.sponsor.SponsorName)) {
        this.sponsor.SponsorName = this.registration.Registration.OrgName;
      }

      if (profile && profile.Website)
        this.sponsor.SponsorWebsite = /^https?:\/\//i.test(profile.Website.trim()) ? profile.Website : 'http://' + profile.Website;
      else this.sponsor.SponsorWebsite = '';
    }

    this.initialLoadComplete = true;
  };

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();

    valid.isValid = true;

    return valid;
  };

  public setImageProfileIdFilter = (profileId: number): void => {
    this.sponsorImageSelector.setImageProfileIdFilter(profileId);
  };

  /**
   * triggered by checkbox change
   * @param display
   */
  public handleInvertedDoNotDisplayChange(display: boolean): void {
    console.error(display);
    if (this.sponsor) this.sponsor.DoNotDisplay = !display;
  }
}
